import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import {
  licenseeFetchTableData,
  licenseeClearStateList,
} from 'reducers/licensee/reducer'
import { LICENSEE_CREATE, LICENSEE_EDIT } from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateColumn from 'types/table/DateColumn'
import Sort from 'lib/psfs/Sort'
import ActiveColumn from 'types/table/ActiveColumn'
import messages from './translate'

class LicenseeList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.licenseeFetchTableData
    this.clearReducerState = props.licenseeClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.licenseeList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.licenseeList),
      link: LICENSEE_CREATE,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new ActiveColumn('visibleInUi', formatMessage(messages.visibleInUi), {
        sorting: true,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editLicensee), row => {
        history.push(UrlHelper.create(LICENSEE_EDIT, { id: row.id }))
      }),
    )

    actions.add(
      new Action('delete', formatMessage(messages.removeLicensee), row => {
        this.props.setOpenDialog(true)
        this.props.setConfirmParams({
          entityId: row.id,
          psfs: this.psfs,
        })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['licensee', 'tableData']),
  }),
  {
    licenseeFetchTableData,
    licenseeClearStateList,
  },
)(injectIntl(LicenseeList))
